__turbopack_context__.v({
  "benefit": "-_2MBq_benefit",
  "benefits-container": "-_2MBq_benefits-container",
  "billed-at": "-_2MBq_billed-at",
  "caption": "-_2MBq_caption",
  "card-header": "-_2MBq_card-header",
  "cta": "-_2MBq_cta",
  "cta-container": "-_2MBq_cta-container",
  "disclaimer": "-_2MBq_disclaimer",
  "numbered-disclaimers": "-_2MBq_numbered-disclaimers",
  "price": "-_2MBq_price",
  "primary": "-_2MBq_primary",
  "productCard": "-_2MBq_productCard",
  "root": "-_2MBq_root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "row": "-_2MBq_row",
  "save-tag": "-_2MBq_save-tag",
  "state-icon": "-_2MBq_state-icon",
});
